import React, { useState } from "react";

import { confirmPasswordReset } from "firebase/auth";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { auth } from "../firebase/firebaseConfig";

const ResetWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #121212;
  padding: 20px;
`;

const ResetCard = styled.div`
  background: #1f1f1f;
  padding: 32px;
  border-radius: 16px;
  width: 400px;
  max-width: 90%;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);

  h2 {
    margin-bottom: 16px;
    color: #a855f7;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 14px;
  margin-bottom: 16px;
  border-radius: 10px;
  border: 1px solid #444;
  background: #2a2a2a;
  color: #fff;
`;

const Button = styled.button`
  width: 100%;
  padding: 14px 0;
  border: none;
  border-radius: 12px;
  background: #a855f7;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [searchParams] = useSearchParams();

  const handleReset = async () => {
    const oobCode = searchParams.get("oobCode"); // comes from Firebase link
    if (!oobCode) {
      setMessage("Invalid or expired reset link.");
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setMessage("✅ Password reset successful! You can now login.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to reset password. Try again.");
    }
  };

  return (
    <ResetWrapper>
      <ResetCard>
        <h2>Reset Your Password</h2>
        <Input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button onClick={handleReset}>Update Password</Button>
        {message && <p style={{ marginTop: "10px" }}>{message}</p>}
      </ResetCard>
    </ResetWrapper>
  );
};

export default ResetPassword;
